import React from 'react';
import { ButtonBase, ButtonBaseProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

/**
 * This component is custom made for the UnitNumberInput component.
 * It should not be used anywhere else unless it's generalized for other use cases.
 */

type UnitButtonProps = {
  children: React.ReactNode;
} & ButtonBaseProps;

const useStyles = makeStyles()((theme) => ({
  button: {
    fontFamily: theme.typography.caption.fontFamily,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.caption.fontWeight,
    lineHeight: theme.typography.caption.lineHeight,
    letterSpacing: theme.typography.caption.letterSpacing,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.25, 0.75),
    borderRadius: theme.shape.borderRadius,
    textTransform: 'none',
    color: theme.palette.text.subtle,
    backgroundColor: 'transparent',
    transition: theme.transitions.create(['background-color', 'color'], {
      duration: theme.transitions.duration.shortest,
    }),
    verticalAlign: 'baseline',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
    },
    '&:focus-visible': {
      outline: 'none',
      backgroundColor: theme.palette.action.selected,
    },
  },
}));

export const UnitButton: React.FC<UnitButtonProps> = ({
  children,
  className,
  disableRipple = true,
  ...props
}) => {
  const { classes, cx } = useStyles();

  return (
    <ButtonBase
      {...props}
      disableRipple={disableRipple}
      className={cx(classes.button, className)}
    >
      {children}
    </ButtonBase>
  );
};
